// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"236":"ff570907","266":"5358af8c","584":"23d23cfa","595":"b798a36f","602":"5f20a5cd","900":"19559de4"}[chunkId] + ".chunk.css";
};